import { useQuery } from "@tanstack/react-query";
import { getVacancy } from "../api/vacancyApi";
import { vacancyKeys } from "../api/vacancyKeys";

// Detalle de una vacante por id.
export const useVacancy = (id: string | undefined) =>
  useQuery({
    queryKey: vacancyKeys.detail(id),
    // `enabled` impide que la query corra sin id, asi que dentro de queryFn ya es string.
    queryFn: () => getVacancy(id!),
    enabled: Boolean(id),
  });
